import { type PromoValue } from '@hungryroot/plan';
import { PromoType } from '@hungryroot/rest/api/get_pricing_config/get';

export const PromoTypeWithDollarEffect = new Set([
  PromoType.FLAT_DISCOUNT,
  PromoType.PERCENT_DISCOUNT,
  PromoType.REFERRAL_DISCOUNT,
]);

export const getApplicablePromo = (promos?: PromoValue[]) => {
  return promos?.find((promo) => {
    return PromoTypeWithDollarEffect.has(promo.type);
  });
};
